import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";

const LoginLogic = () => {
    const [postObj, setPostObj] = useState({});
    const [passwordResetIsOpen, setPasswordResetIsOpen] = useState(false);
    const [resetMessage, setResetMessage] = useState();
    const navigate = useNavigate();
    const { REACT_APP_API_URL } = process.env;
    const [error, setError] = useState();
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ipAddress, setIpAddress] = useState();

    useEffect(() => {
        const getIpAddress = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error('Error fetching IP address:', error);
                return null;
            }
        };
        getIpAddress().then((ip) => {
            setIpAddress(ip);
        });
    }, []);

    const HandleSubmit = async (event) => {
        setError(null);
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${REACT_APP_API_URL}/LoginV2?username=${encodeURIComponent(postObj.username)}&password=${encodeURIComponent(postObj.password)}&ipAddress=${ipAddress}`);

            if (res.ok) {
                const payload = await res.json();
                if (payload.message === 'Reset') {
                    setPasswordResetIsOpen(true);
                } else {
                    navigate('/TwoFactorAuth', { state: { username: postObj.username } });
                }
                setLoading(false);
                setValidated(true);
                return;
            }

            const bodyText = await res.text();
            let message = 'Login failed';
            try {
                const json = JSON.parse(bodyText);
                message = json.message || bodyText;
            } catch {
                message = bodyText;
            }
            setError(message);
        } catch (err) {
            console.error(err);
            //setError(err.message || 'Network error');
        } finally {
            setLoading(false);
            setValidated(true);
        }
    }

    const HandleChange = (e, fieldName) => {
        setError(null)
        setResetMessage(null)
        setPostObj(prev => ({ ...prev, [fieldName]: e.target.value }))
    }
    return (
        <Login
            HandleSubmit={HandleSubmit}
            validated={validated}
            HandleChange={HandleChange}
            passwordResetIsOpen={passwordResetIsOpen}
            setPasswordResetIsOpen={setPasswordResetIsOpen}
            postObj={postObj}
            error={error}
            resetMessage={resetMessage}
            setResetMessage={setResetMessage}
            loading={loading}
        ></Login>
    )
}

export default LoginLogic;